import { render, staticRenderFns } from "./TreatmentViewer.vue?vue&type=template&id=f49a9ae6&"
import script from "./TreatmentViewer.vue?vue&type=script&lang=js&"
export * from "./TreatmentViewer.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentViewer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports